<span id="confirm-dialog-title" class="cdk-visually-hidden">{{ 'Confirm' | translate: {Default: 'Confirm'} }}</span>
<mat-dialog-content id="confirm-dialog-content" role="document" [attr.aria-labelledby]="'confirm-dialog-title'">
    <p *ngIf="localizationCode" appLocalizationPopupDirective [localizationCode]="localizationCode">
        {{ translate.instant(localizationCode) }}
    </p>
    
    <p *ngIf="text">{{ text }}</p>
</mat-dialog-content>

<mat-dialog-actions align="end">
    <button type="button" mat-raised-button appPreventDoubleClick (throttledClick)="close()" [attr.aria-label]="'Cancel' | translate: {Default: 'Cancel'}">
        {{ 'Cancel' | translate: {Default: 'Cancel'} }}
    </button>
    <button
        *ngIf="localizationCode !== null || text !== null"
        type="button"
        cdkFocusInitial
        setColor="primaryColour"
        mat-raised-button
        class="submit-button"
        appPreventDoubleClick (throttledClick)="confirm()"
        [attr.aria-label]="'Confirm' | translate: {Default: 'Confirm'}"
    >
        {{ 'Confirm' | translate: {Default: 'Confirm'} }}
    </button>
</mat-dialog-actions>